import { render, staticRenderFns } from "./TransactionFormPreview.vue?vue&type=template&id=772ec2b1&scoped=true&"
import script from "./TransactionFormPreview.vue?vue&type=script&lang=js&"
export * from "./TransactionFormPreview.vue?vue&type=script&lang=js&"
import style0 from "./TransactionFormPreview.vue?vue&type=style&index=0&id=772ec2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ec2b1",
  null
  
)

export default component.exports